import axios from 'axios';
import {backendHost} from '../../config';

export const postUsers = (params) => {
    return axios.post(`${backendHost}/api/admin/v2/mailing/users`, params);
};